/* unplugin-vue-components disabled */import script from "./indexProjectItemLeft.vue?vue&type=script&setup=true&lang=js"
export * from "./indexProjectItemLeft.vue?vue&type=script&setup=true&lang=js"

import "./indexProjectItemLeft.vue?vue&type=style&index=0&id=1fdddcfd&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fdddcfd"]])

export default __exports__